"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DelegatingGridLayout_1 = tslib_1.__importDefault(require("./DelegatingGridLayout"));
const FetchMoreWidget_1 = tslib_1.__importDefault(require("./FetchMoreWidget"));
class FetchMoreGridLayout extends DelegatingGridLayout_1.default {
    constructor(gridConfig, scrollContainer) {
        super();
        this.delegate = this;
        this.gridConfig = gridConfig;
        this.fetchMoreWidget = new FetchMoreWidget_1.default(scrollContainer);
    }
    arm(cb) {
        this.fetchMoreWidget.arm(cb);
    }
    disarm() {
        this.fetchMoreWidget.disarm();
    }
    hide() {
        this.fetchMoreWidget.hide();
    }
    numInitialDomRows() {
        return this.delegate.numInitialDomRows() + 1;
    }
    isEmpty() {
        return this.delegate.numInitialDomRows() === 0;
    }
    getCellStyle(row, column) {
        if (this.isMarkerRow(row)) {
            return ["grid-loading"];
        }
        return this.delegate.getCellStyle(row, column);
    }
    getColSpan(row, column) {
        if (this.isMarkerRow(row) && column === 0) {
            return this.gridConfig.getNumberOfColumns();
        }
        return this.delegate.getColSpan(row, column);
    }
    renderCell(td, ctx, row, column) {
        if (this.isMarkerRow(row)) {
            ctx.setWidget(this.fetchMoreWidget);
        }
        else {
            this.delegate.renderCell(td, ctx, row, column);
        }
    }
    getRowStyle(row) {
        if (this.isMarkerRow(row)) {
            return ["hidden"];
        }
        return this.delegate.getRowStyle(row);
    }
    getRowAttributes(row) {
        if (this.isMarkerRow(row)) {
            return "";
        }
        else {
            return this.delegate.getRowAttributes(row - 1);
        }
    }
    isMarkerRow(row) {
        return row === this.delegate.numInitialDomRows();
    }
}
exports.default = FetchMoreGridLayout;
//# sourceMappingURL=FetchMoreGridLayout.js.map